import { useState, useEffect } from 'react';

import { useGetTargetOrigin } from './useGetTargetOrigin';

const initialState = {
  lastMessage: undefined,
  messages: [],
};

export const useRetailLaunchpadMessaging = (isTruePortal) => {
  const getTargetOrigins = useGetTargetOrigin();
  const [messageState, setMessageState] = useState(initialState);

  function postMessage(message) {
    const docRef = document.referrer;
    if (!docRef || !getTargetOrigins.length) return;

    let docRefOrigin;
    try {
      docRefOrigin = new URL(docRef).origin;
    } catch {
      return;
    }

    const isAllowed = getTargetOrigins.some((target) => {
      try {
        return new URL(target).origin === docRefOrigin;
      } catch {
        return false;
      }
    });

    if (isAllowed) {
      window.parent.postMessage(message, docRefOrigin);
    }
  }

  function updateState(data) {
    setMessageState((prevState) => ({
      lastMessage: data,
      messages: prevState.messages.concat(data),
    }));
  }

  // TODO: prevent useEffect from running when not TRUE
  useEffect(() => {
    const onWindowMessage = (e) => updateState(e.data);

    if (isTruePortal) {
      window.addEventListener('message', onWindowMessage);
    }
    return () => {
      window.removeEventListener('message', onWindowMessage);
    };
  }, [isTruePortal]);

  return {
    messageState,
    postMessage,
  };
};
